import React from "react";
import "./Navbar.css";

const Navbar = () => {

    const scrollToHome = () => {
        const projectsSection = document.getElementById('homedir');
        projectsSection.scrollIntoView({ behavior: 'smooth' });
      };

    const scrollToAboutUs = () => {
        const projectsSection = document.getElementById('AboutUsComp');
        projectsSection.scrollIntoView({ behavior: 'smooth' });
      };
    

    const scrollToServices = () => {
        const techAndSkillsSection = document.getElementById('servicesComp');
        techAndSkillsSection.scrollIntoView({ behavior: 'smooth' });
      };

    const scrollToPlans = () => {
        const techAndSkillsSection = document.getElementById('plansComp');
        techAndSkillsSection.scrollIntoView({ behavior: 'smooth' });
      };

    const scrollToBlog = () => {
        const techAndSkillsSection = document.getElementById('blogsComp');
        techAndSkillsSection.scrollIntoView({ behavior: 'smooth' });
      };

    const scrollToMessage = () => {
        const contactSection = document.getElementById('MessageUs');
        contactSection.scrollIntoView({ behavior: 'smooth' });
      };

  return (
    <div className="navbar">
      <div className="logo">
        <img
          id="Logophoto"
          src={require("../../assets/NDLogo2.png")}
          alt="Description of image"
        />
        <div id="Name">
        <img
            id="NDname"
            src={require("../../assets/NDname.png")}
            alt="Description of image"
          />
        </div>
      </div>
      <div className="links">
        <a onClick={scrollToHome} className="homelink navLinks">Home</a>
        <a onClick={scrollToAboutUs} className="navLinks">About Us</a>
        <a onClick={scrollToServices} className="navLinks">Services</a>
        <a onClick={scrollToPlans} className="navLinks">Plans</a>
        <a onClick={scrollToBlog} className="navLinks">Blog</a>

        <button className="nav-btn" onClick={scrollToMessage}> Join Us!</button>
        
      </div>
    </div>
  );
};

export default Navbar;
